import ApiService from '@boServices/apiService';

class TestService extends ApiService {
    /** Tests whose reference or title holds each word of `search`, ordered by reference: `limit` of them at most (50 at most). */
    searchTests({ search = '', limit = 20, signal } = {}) {
        const params = new URLSearchParams({ limit: String(limit) });
        if (search) params.set('search', search);
        return this.fetchWithHeaders(`/api/v2/backoffice/tests?${params.toString()}`, 'GET', { signal });
    }

    /**
     * One page of the tests, as `{ items, total, page, perPage }`: those whose reference or title holds each word of `search`,
     * of one of the `statuses`, `languageIds` and `levelIds` given (each filter is ignored when empty), ordered by
     * `sortBy` (a column, prefixed with "-" for the descending order).
     */
    getTests({ search = '', page = 1, perPage = 20, statuses = [], languageIds = [], levelIds = [], sortBy = '', signal } = {}) {
        const params = new URLSearchParams({ page: String(page), perPage: String(perPage) });
        if (search) params.set('search', search);
        if (statuses.length) params.set('statuses', statuses.join(','));
        if (languageIds.length) params.set('languageIds', languageIds.join(','));
        if (levelIds.length) params.set('levelIds', levelIds.join(','));
        if (sortBy) params.set('sortBy', sortBy);
        return this.fetchWithHeaders(`/api/v2/backoffice/tests?${params.toString()}`, 'GET', { signal });
    }

    getTest(reference) {
        return this.fetchWithHeaders(`/api/v2/backoffice/tests/${encodeURIComponent(reference)}`, 'GET');
    }

    /** Creates a test and resolves to it. Rejects with a 409 status when its reference already exists. */
    createTest(payload) {
        return this.fetchWithHeaders('/api/v2/backoffice/tests', 'POST', {
            body: JSON.stringify(payload),
        });
    }

    /** Updates a test and resolves to it, with the collections that hold it. */
    updateTest(reference, payload) {
        return this.fetchWithHeaders(`/api/v2/backoffice/tests/${encodeURIComponent(reference)}`, 'PUT', {
            body: JSON.stringify(payload),
        });
    }

    /** Levels of the tests, as `{ id, nom }` (`nom` being the French label). */
    getLevels() {
        return this.fetchWithHeaders('/api/v2/backoffice/niveaux', 'GET');
    }
}

export default TestService;
